// Local translations
export const T = {
  en_GB: {
    title: "Single sign-on needs to be confirmed",
    body: (date: string) =>
      `Your organization's address has changed. An administrator has to set up and confirm the new single sign-on address by ${date}. On that date single sign-on switches to the new address automatically and stops working until the identity provider has been updated.`,
    bodyNoDate:
      "Your organization's address has changed. An administrator has to set up and confirm the new single sign-on address, otherwise single sign-on may stop working.",
    bodyOverdue: (date: string) =>
      `Your organization's address has changed and the grace period ended on ${date}. Single sign-on is switching to the new address and stops working until the identity provider has been updated.`,
    confirmLink: "Go to SSO settings",
    tellAdmin: "Please let an administrator know.",
    dismiss: "Dismiss",
  },
  nb_NO: {
    title: "Enkel pålogging må bekreftes",
    body: (date: string) =>
      `Organisasjonens adresse er endret. En administrator må sette opp og bekrefte den nye påloggingsadressen for enkel pålogging innen ${date}. Da bytter enkel pålogging automatisk til den nye adressen og virker ikke før identitetsleverandøren er oppdatert.`,
    bodyNoDate:
      "Organisasjonens adresse er endret. En administrator må sette opp og bekrefte den nye påloggingsadressen for enkel pålogging, ellers kan enkel pålogging slutte å virke.",
    bodyOverdue: (date: string) =>
      `Organisasjonens adresse er endret, og fristen gikk ut ${date}. Enkel pålogging bytter til den nye adressen og virker ikke før identitetsleverandøren er oppdatert.`,
    confirmLink: "Gå til SSO-innstillinger",
    tellAdmin: "Gi beskjed til en administrator.",
    dismiss: "Lukk",
  },
} as const;
